<template>
  <span>{{ result }}</span>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    result() {
      if (!this.value || !this.type) return this.value

      if (this.type === 'date') {
        const valueTime = moment(new Date(this.value), 'YYYYMMDD HH:mm:ss')
        const differenceInSeconds = moment().diff(valueTime, 'seconds')

        // 7 days = 604800 seconds
        if (differenceInSeconds > 604800) {
          return valueTime.locale('en').format('DD MMM YYYY')
        }

        let result = moment(new Date(this.value), 'YYYYMMDD').locale('en').fromNow()
        if (result === 'a few seconds ago') {
          result = 'Just now'
        }

        return result
      }

      if (this.type === 'number') {
        return this.value.toLocaleString('en-GB')
      }

      return null
    },
  },
}
</script>
